module.exports = __webpack_public_path__ + "img/footer-bg.7151653e.png";